import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Status } from 'ui-widgets';
import {
  representativesSelector,
  representativesStatus,
} from '../redux/selectors/representativesSelector';
import { Option } from '../types';

export const useRepresentatives = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isError, setIsError] = useState(false);
  const [representativesList, setRepresentativesList] = useState<Option[]>([]);
  const representatives = useSelector(representativesSelector);
  const status = useSelector(representativesStatus);

  useEffect(() => {
    if (status === Status.LOADED) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [representatives, status]);

  useEffect(() => {
    if (status === Status.ERROR) {
      setIsError(true);
      setIsLoading(false);
    } else {
      setIsError(false);
    }
  }, [representatives, status]);

  useEffect(() => {
    if (status === Status.LOADED) {
      const { assignable_reps, assigned_rep } =
        representatives.representativesList;
      const reps = assignable_reps.map(
        (rep): Option => ({
          label: `${rep.first_name} ${rep.last_name}`,
          value: parseInt(rep.id),
        }),
      );

      if (assigned_rep !== null) {
        const isAssignedRepInList = reps.some(
          (rep) => rep.value === parseInt(assigned_rep.id),
        );
        if (!isAssignedRepInList) {
          reps.unshift({
            label: `${assigned_rep.first_name} ${assigned_rep.last_name}`,
            value: parseInt(assigned_rep.id),
          });
        }
      }
      setRepresentativesList(reps);
    }
  }, [representatives]);

  useEffect(() => {
    if (!isLoading) {
      setIsEmpty(representativesList.length === 0);
    }
  }, [isLoading, representativesList]);

  return { representativesList, isLoading, isEmpty, isError };
};
